export default "__VITE_ASSET__8fda8b19__"